import { render, staticRenderFns } from "./pointsShopGoodsItem.vue?vue&type=template&id=6dfe9de2&scoped=true"
import script from "./pointsShopGoodsItem.vue?vue&type=script&lang=js"
export * from "./pointsShopGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./pointsShopGoodsItem.vue?vue&type=style&index=0&id=6dfe9de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfe9de2",
  null
  
)

export default component.exports